import type { EditorView } from "@codemirror/view";
import { store } from "./store";
import { mountEditor } from "./editor";
import { renderToolbar } from "./toolbar";
import { renderTabs } from "./tabs";
import { initExplorer } from "./explorer";
import { initTopBar } from "./top-bar";
import { initReviewPanel } from "./review-panel";

let currentView: EditorView | null = null;
let currentPath: string | null = null;

function renderEditorArea() {
  const container = document.getElementById("editor-container")!;
  const emptyState = document.getElementById("empty-state")!;
  const toolbar = document.getElementById("mobile-toolbar")!;
  const { activePath, openFiles } = store.getState();
  const activeFile = openFiles.find((f) => f.path === activePath);

  if (!activeFile) {
    if (currentView) {
      currentView.destroy();
      currentView = null;
      currentPath = null;
    }
    container.innerHTML = "";
    emptyState.style.display = "flex";
    toolbar.style.display = "none";
    return;
  }

  emptyState.style.display = "none";
  toolbar.style.display = "flex";

  if (currentPath !== activeFile.path) {
    if (currentView) currentView.destroy();
    container.innerHTML = "";
    currentPath = activeFile.path;
    currentView = mountEditor(container, activeFile.path, activeFile.content, (value) => {
      store.getState().setContent(activeFile.path, value);
    });
    renderToolbar(toolbar, () => currentView);
  }
}

function main() {
  initTopBar();
  initExplorer();
  initReviewPanel();
  renderEditorArea();
  renderTabs();

  store.subscribe((state, prev) => {
    if (state.openFiles !== prev.openFiles || state.activePath !== prev.activePath) {
      renderEditorArea();
      renderTabs();
    }
  });

  window.addEventListener("keydown", (e) => {
    if ((e.metaKey || e.ctrlKey) && e.key === "s") {
      e.preventDefault();
      store.getState().saveActiveFile();
    }
  });

  store.getState().loadTree();
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", main);
} else {
  main();
}
